import { Table } from '@devexpress/dx-react-grid-material-ui';
import { withRouter } from 'react-router-dom';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ShipmentTableStyles from '../../components/Global/Table/Table.Styles';
import { withStyles } from '@material-ui/core/styles';
export class TableRow extends Component {
  static propTypes = {
    row: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    tableRow: PropTypes.object.isRequired
  };

  render() {
    const { children, row, tableRow, history, classes } = this.props;
    return (
      <Table.Row
        className={classes.tableRowHover}
        row={row}
        tableRow={tableRow}
        onClick={() => {
          const shipmentUrl = `/shipments/${row.id}`;
          if (row.status === 'Saved') {
            history.push(`${shipmentUrl}/edit`);
          } else {
            history.push(shipmentUrl);
          }
        }}
        style={{
          cursor: 'pointer'
        }}
      >
        {children}
      </Table.Row>
    );
  }
}

const styledTableRow = withStyles(ShipmentTableStyles)(TableRow);
export default withRouter(styledTableRow);
